
    import "src/shared/components/wms/AwaitingPickup/index.module.scss?farm_css_modules";
    
    export default {"card": `card-f7981ed1`,"companyName": `companyName-f7981ed1`,"main": `main-f7981ed1`,"title": `title-f7981ed1`,"value": `value-f7981ed1`}
    